














































import DraggableWidget from '@/components/util/DraggableWidget.vue';
import WorkOrderListView from '@/components/orders/WorkOrderListView.vue';

import { Component, Prop, Vue } from 'vue-property-decorator';
import { Property, Workorder } from 'performo-api';
import { SortChangedEvent } from '@/models/SortChangedEvent';

@Component({ components: { DraggableWidget, WorkOrderListView } })
export default class MyOrdersWidget extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop() private widgetConfiguration: any;

  private pageNumber = 1;
  private pageSize = 25;

  private sortColumn!: string;
  private sortDirection!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get query(): any {
    let q = {
      ...this.widgetConfiguration.query,
      skip: this.pageSize * (this.pageNumber - 1) + 1
    };

    if (this.sortColumn) {
      q.sortColumn = this.sortColumn;
    }
    if (this.sortDirection) {
      q.sortDirection = this.sortDirection;
    }

    return q;
  }

  get currentProperty(): Property {
    return this.$store.getters.currentProperty;
  }

  private async paginationChangeHandler(pageNumber: number) {
    this.pageNumber = pageNumber;
  }

  private display = this.$store.state.settings.allowRequestersToViewAssignTo
    ? [
        { displayName: 'Work #', columnName: 'orderNumber' },
        {
          displayName: this.currentProperty.location1Label || 'Building',
          columnName: 'building'
        },
        { displayName: 'Status', columnName: 'orderStatus' },
        { displayName: 'Order By', columnName: 'orderBy' },
        { displayName: 'Assigned To', columnName: 'assignTo' }
      ]
    : [
        { displayName: 'Work #', columnName: 'orderNumber' },
        {
          displayName: this.currentProperty.location1Label || 'Building',
          columnName: 'building'
        },
        { displayName: 'Status', columnName: 'orderStatus' },
        { displayName: 'Order By', columnName: 'orderBy' }
      ];

  data() {
    return {
      sortColumn: undefined,
      sortDirection: undefined,
      pageNumber: 1
    };
  }

  private orderClickedHandler(order: Workorder) {
    if (order.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: order.workorderId }
      });
    }
  }

  private sortChangedHandler(sort: SortChangedEvent) {
    this.sortColumn = sort.column;
    this.sortDirection = sort.direction === 1 ? 'ascend' : 'descend';
  }

  private doWorkOrderList() {
    // blank
  }
}

Vue.component('MyOrdersWidget', MyOrdersWidget);
